import React from 'react';
import { Route, Switch } from 'react-router-dom';

import ImportDetail from './ImportDetail';
import ImportsList from './ImportsList';

const PinsAdminImports = () => (
  <Switch>
    <Route component={ImportDetail} path="/pinsadmin/imports/:importId" />
    <Route component={ImportsList} path="/pinsadmin/imports" />
  </Switch>
);

export default PinsAdminImports;
